import * as React from "react";

import { Classes, Button } from "@blueprintjs/core";
import { Chart } from "chart.js";

class DarkModeSwitch extends React.Component {
  constructor() {
    super();
    if (localStorage.getItem('dark') === undefined)
      localStorage.setItem('dark', false);
    this.state = {
      dark: JSON.parse(localStorage.getItem('dark'))
    }
  }

  render() {
    Chart.defaults.color = (this.state.dark) ? "white" : "black";
    document.body.className = ((this.state.dark) ? Classes.DARK : "bp5-body");
    return (
      <Button
        minimal={true}
        icon={this.state.dark ? "flash" : "moon"}
        onClick={(cb) => {
          this.setState({ dark: !this.state.dark }, () => {
            localStorage.setItem('dark', this.state.dark);
            document.body.className = ((this.state.dark) ? Classes.DARK : "bp5-body");
            Chart.defaults.color = (this.state.dark) ? "white" : "black";
          });
        }}
      />
    );
  }
}

export default DarkModeSwitch
